import React, { useEffect, useState, useRef } from 'react';

import Dropdown from '../../components/Dropdown/Dropdown';
import CustomDatePicker from '../../components/CustomDatePicker';
import AddNewFounder from '../../components/Founders/AddNewFounder';
import DataTableList from '../../components/DataTable/DataTableList';
import SingleSuspendPopup from '../../components/SingleSuspendPopup';
import MultipleSuspendPopup from '../../components/MultipleSuspendPopup';
import NoResults from '../../components/Noresults';

import { useStaticDataStore } from '../../stores/staticData';
import { USER_MEMBER } from '../../constants/common';
import { founderListApi, getUserDetailApi, suspendUserApi } from '../../api/usersApi';
import { dateFormat, formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png';
import EditUser from '../../components/EditSlider/EditUser';
const ActiveFounders = (props) => {
  const {
    setShowAddNewFounderPopup,
    setSelectFounder,
    isLoading,
    isLoadingData,
    founderList,
    totalPage,
    setEditFounder,
    setIsLoadingData,
    currentPage,
    setSearchQuery,
    searchQuery,
    setFilterFounder,
    filterFounder,
    setShowSuspendPopup,
    setMultipleSuspendPopup,
    selectedRows,
    setSelectedRows,
    isAllSelected,
    setIsAllSelected,
    toggleSelect,
    setErrorMessage,
    setCurrentPage,
    setReason,
    LazyImage } = props;

  const { data: staticData } = useStaticDataStore();

  const userUniversityRef = useRef(null);
  const userIndustryRef = useRef(null);
  const userStartupStagesRef = useRef(null);
  const userFounderRef = useRef(null);
  const userInvestmentTermRef = useRef(null);
  const userRegisterDateRef = useRef(null);

  let university = [];
  if (staticData?.university?.length) {
    university = staticData?.university;
  }

  let industryTags = [];
  if (staticData?.industryTags?.length) {
    industryTags = staticData?.industryTags;
  }

  let startupStages = [];
  if (staticData?.startupStages?.length) {
    startupStages = staticData?.startupStages;
  }

  let investmentTerm = [];
  if (staticData?.investmentTerm?.length) {
    investmentTerm = staticData?.investmentTerm;
  }

  const userMember = USER_MEMBER;

  const [userUniversitySelect, setUserUniversitySelect] = useState(false);
  const [userIndustrySelect, setUserIndustrySelect] = useState(false);
  const [userStartupStagesSelect, setUserStartupStagesSelect] = useState(false);
  const [userFoundersSelect, setUserFoundersSelect] = useState(false);
  const [userInvestmentTermSelect, setUserInvestmentTermSelect] = useState(false);
  const [userRegisterDateSelect, setUserRegisterDateSelect] = useState(false);
  const [columnWidths, setColumnWidths] = useState([]);

  useEffect(() => {
    if (founderList?.length > 0) {
      calculateColumnWidths().then(() => {
        setTimeout(() => {
          setIsLoadingData(false);
        }, 1000);
      });
    }
  }, [founderList]);

  const handleSearchQuery = (e) => {
    if (e.target) {
      setSearchQuery(e.target.value);
    }
  };

  const handleDelete = async () => {
    if (
      selectedRows?.length === 1
    ) {
      const selected = founderList?.find((row) => row?.userId === selectedRows[0]);
      if (selected) {
        setSelectFounder(selected);
      }
      setShowSuspendPopup(true);
    }

    if (
      selectedRows?.length > 1
    ) {
      setMultipleSuspendPopup(true);
    }
    setErrorMessage('')
  };

  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(founderList?.map((row) => row?.userId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const calculateColumnWidths = () => {
    return new Promise((resolve) => {
      const tempWidths = founderList?.reduce((acc, row) => {
        Object?.keys(row)?.forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];

          let maxContentLength = 0;

          if (key === 'industryTags' || key === 'startupStages' || key === 'university') {
            const categories = row[key];

            if (categories?.length > 1) {
              let tempCatLength = 0;

              for (let i = 0; i < 1; i++) {
                tempCatLength = tempCatLength + categories[i]?.length;
              }

              maxContentLength = Math?.max(tempCatLength, title?.length);
            } else {
              if (categories?.length == 0) {
                maxContentLength = Math?.max(dataValue?.length + 5);
              } else {
                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
              }
            }
          } else {
            maxContentLength = Math?.max(dataValue?.length, title?.length);
          }

          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});
      if (tempWidths !== undefined) {
        const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {
          if (key === 'industryTags' || key === 'startupStages' || key === 'university') {
            founderList?.forEach((row) => {
              const categoryWidth = tempWidths[key] * 10 + 40;
              acc[key] = `${categoryWidth}px`;
            });
          } else {
            acc[key] = `${tempWidths[key] * 10 + 40}px`;
          }
          return acc;
        }, {});

        setColumnWidths(widthMap);
      }
      resolve();
    });
  };

  const columns = [
    {
      name: 'Founder name',
      selector: (row) => row?.name,
      cell: (row) => {
        return (
          <div className="founder-content founderTable" onClick={() => { handleEditClick(row); setReason('') }}>
            <LazyImage
              src={row?.profileImg || avatar}
              alt="Active founder"
            />
            <div className="founder-brief">
              <span className="founder-name">{row?.name || 'NO NAME'}</span>
            </div>
          </div>
        );
      },
      sortable: true,
      minWidth:
        columnWidths['name'] &&
        `${parseInt(columnWidths['name']) + 60}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Email address',
      selector: (row) => row?.email,
      cell: (row) => {
        return <p className="user-mail">{row?.email}</p>;
      },
      sortable: true,
      width: columnWidths['email'] && (parseInt(columnWidths['email']) > 300) ? '300px' : `${parseInt(columnWidths['email'])}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Option',
      selector: (row) => row?.university,
      cell: (row) => {
        const optionKeys = row.university?.map((opt) => opt?.trim()) || [];

        const matchedLabels = optionKeys?.map((item) => {
          const matchOption = university?.find((opt) => opt?.key === item);
          return matchOption ? matchOption.value : item;
        });

        const options = matchedLabels.slice(0, 4);

        return (
          <div className="universityCategory">
            <div>
              {options.join(', ')}
            </div>
          </div>
        );
      },

      sortable: false,
      width: columnWidths['university'] && `${parseInt(columnWidths['university']) + 200}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Startup name',
      selector: (row) => row?.companyName,
      cell: (row) => {
        return <p className='user-mail'>{row?.companyName}</p>;
      },
      sortable: true,
      minWidth:
        columnWidths['companyName'] &&
        `${parseInt(columnWidths['companyName']) + 10}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Industry',
      selector: (row) => row?.industryTags || staticData?.industryTags?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const industryTags = row?.industryTags?.length
          ? row?.industryTags
          : staticData?.industryTags?.map(item => item?.key) || [];

        const industry = industryTags?.slice(0, 1);
        const industryFull = industryTags?.slice(1);

        const getIndustryValue = (key) => {
          const found = staticData?.industryTags?.find(item => item?.key === key);
          return found ? found?.value : key;
        };
        return (
          <div className="industriesCategory">
            <div>
              {industry?.map((key, index) => (
                <span key={index}>{getIndustryValue(key)}</span>
              ))}
              {industryTags?.length > 1 && (
                <div className="industriesList">
                  <span>+{industryTags?.length - 1}</span>
                  <div className="industriesTooltip ">
                    {industryFull?.map((key, idx) => (
                      <p key={idx}>{getIndustryValue(key)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      width:
        columnWidths['industryTags'] &&
        `${parseInt(columnWidths['industryTags']) + 40}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        lineHeight: '20px',
      },
    },
    {
      name: 'Startup stage',
      selector: (row) => row?.startupStages || staticData?.startupStages?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const startupStages = row?.startupStages?.length
          ? row?.startupStages
          : staticData?.startupStages?.map(item => item?.key) || [];

        const startupStage = startupStages?.slice(0, 1);
        const startupStageFull = startupStages?.slice(1);

        const getStartupStageValue = (key) => {
          const found = staticData?.startupStages?.find(item => item?.key === key);
          return found ? found?.value : key;
        };
        return (
          <div className="industriesCategory">
            <div>
              {startupStage?.map((item, index) => (
                <span key={index}>{getStartupStageValue(item)}</span>
              ))}

              {startupStages?.length > 1 && (
                <div className="industriesList">
                  <span>+{startupStages?.length - 1}</span>
                  <div className="industriesTooltip">
                    {startupStageFull?.map((item, idx) => (
                      <p key={idx}>{getStartupStageValue(item)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        width:
          columnWidths['startupStages'] &&
          `${parseInt(columnWidths['startupStages']) + 200}px`,
        fontSize: '12px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.24px',
      },
    },
    {
      name: 'Founders',
      selector: (row) => row?.teamCount,
      cell: (row) => {
        return <p className="user-founders">{row?.teamCount}</p>;
      },
      sortable: true,
      width:
        columnWidths['teamCount'] &&
        `${parseInt(columnWidths['teamCount']) + 50}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Investment term',
      selector: (row) => row?.investmentTerm,
      cell: (row) => {
        const term =
          investmentTerm?.find((item) => item?.key === row?.investmentTerm)
            ?.value || row?.investmentTerm;
        return <p className="user-founders">{term}</p>;
      },
      sortable: true,
      width:
        founderList?.some(row => row?.investmentTerm === 'GRANTS')
          ? '280px'
          : columnWidths['investmentTerm'] && `${parseInt(columnWidths['investmentTerm']) + 100}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Date registered',
      selector: (row) => row?.registeredAt,
      cell: (row) => {
        return <p className="user-founders">{formattedDate(row?.registeredAt)}</p>;
      },
      sortable: true,
      minWidth:
        columnWidths['registeredAt'] &&
        `${parseInt(columnWidths['registeredAt']) - 150}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Last active',
      selector: (row) => row?.lastActive,
      cell: (row) => {
        return <p className="user-founders">{formattedDate(row?.lastActive || row?.registeredAt)}</p>;
      },
      sortable: true,
      minWidth:
        columnWidths['lastActive'] &&
        `${parseInt(columnWidths['lastActive']) - 250}px`,
      style: {
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: '14px',
        color: '#05171A',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <>
            <div className="table-actions">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                onClick={() => { handleEditClick(row); setReason(''); }}
              >
                <path
                  d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z"
                  stroke="#05171A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                onClick={() => {
                  setShowSuspendPopup(true);
                  setSelectFounder(row);
                  setReason('');
                  setErrorMessage('')
                }}
              >
                <path
                  d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5"
                  stroke="#05171A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </>
        );
      },
      justifyContent: 'flex-end',
      allowOverflow: true,
      button: true,
      minWidth: '55px',
      paddingRight: '16px',
      width: '80px',
      style: {
        textAlign: 'right',
        minWidth: '80px',
        paddingLeft: 0,
        paddingRight: '16px',
        paddingTop: '15px',
        paddingBottom: '15px',
      },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '24px',
        color: '#666666',
      },
    },
  };

  const handleEditClick = async (row) => {
    try {
      setEditFounder(true);
      setSelectFounder(row);
    } catch (error) {
      console.error('Failed to fetch user detail on edit:', error);
    }
  };

  return (
    <div className="active-founders">
      <div className="active-founder-top">
        <div className="pagesSearch twoItemWrap">
          <div className="pageSearchInput">
            <input
              type="text"
              name="pages_search"
              className="inputFields"
              id="pages_search"
              placeholder={'Search active founders...'}
              autoComplete="off"
              value={searchQuery}
              onChange={handleSearchQuery}
            />
            <img src={search} alt="Search" />
          </div>

          <Dropdown
            ref={userUniversityRef}
            selectedDropdown={userUniversitySelect}
            setSelectedDropdown={setUserUniversitySelect}
            items={university}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                university: newValue
              }))
            }
            selectedValue={filterFounder?.university ?? []}
            name={'University'}
          />

          <Dropdown
            ref={userIndustryRef}
            selectedDropdown={userIndustrySelect}
            setSelectedDropdown={setUserIndustrySelect}
            items={industryTags}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                industry: newValue
              }))
            }
            selectedValue={filterFounder?.industry ?? []}
            name={'Industry'}
          />

          <Dropdown
            ref={userStartupStagesRef}
            selectedDropdown={userStartupStagesSelect}
            setSelectedDropdown={setUserStartupStagesSelect}
            items={startupStages}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                startupStage: newValue
              }))
            }
            selectedValue={filterFounder?.startupStage ?? []}
            name={'Startup stage'}
          />

          <Dropdown
            ref={userFounderRef}
            selectedDropdown={userFoundersSelect}
            setSelectedDropdown={setUserFoundersSelect}
            items={userMember}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                teamCount: newValue
              }))
            }
            selectedValue={filterFounder?.teamCount ?? []}
            name={'Founders'}
          />

          <Dropdown
            ref={userInvestmentTermRef}
            selectedDropdown={userInvestmentTermSelect}
            setSelectedDropdown={setUserInvestmentTermSelect}
            items={investmentTerm}
            setSelectedValue={(newValue) =>
              setFilterFounder((prev) => ({
                ...prev,
                investmentTerm: newValue
              }))
            }
            selectedValue={filterFounder?.investmentTerm ?? []}
            name={'Investment Terms'}
          />

          <CustomDatePicker
            onApply={(dateRange) => {
              setFilterFounder(prev => ({
                ...prev,
                registedDate: dateRange
              }));
              setUserRegisterDateSelect(false);
            }}
            selectedDate={filterFounder?.registedDate}
            onCancel={() => setUserRegisterDateSelect(false)}
            isSelectDate={userRegisterDateSelect}
            ref={userRegisterDateRef}
            setSelectDate={setUserRegisterDateSelect}
            label={'Registered Date'}
          />
        </div>

        <div className="new-founder">
          {selectedRows?.length > 0 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              onClick={() => {
                handleDelete();
                setReason('')
              }}
            >
              <path
                d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5"
                stroke="#05171A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          <button
            className="new-founder-button"
            onClick={() => {
              setShowAddNewFounderPopup(true);
              setErrorMessage('');
            }}
          >
            New Founder
          </button>
        </div>
      </div>

      <div className="table-pagination-wrapper founder-list">
        <div
          className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list' : ''
            }`}
        >
          <DataTableList
            data={founderList}
            columns={columns}
            customStyles={customStyles}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            currentPage={currentPage}
            selectableRowsComponent="input"
            selectableRows={true}
            selectAllRows={isAllSelected}
            onSelectAllChange={handleMasterCheckboxChange}
            clearSelectedRows={toggleSelect}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows?.map((row) => row?.userId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds?.length === founderList?.length);
            }}
            progressPending={isLoading}
            progressComponent={
              <div className="loader-container">
                {' '}
                <div className="loader"></div>{' '}
              </div>
            }
            noDataComponent={
              <NoResults
                title="No active founders yet"
                description="Looks like there aren’t any active founders to show right now. Keep an eye out - new talent is joining all the time!"
              />
            }
          />
        </div>
      </div>

    </div>
  );
};

export default ActiveFounders;